export const NOTIFICATIONS_FETCH_INTERVAL_SECONDS = 60;


// WEBPACK FOOTER //
// ./src/constants/configurationConstants.js